/*
 * Home page collection sliders: size panel for quick add (snippets/ll-slider-quick-add.liquid).
 * Desktop (mouse): the panel slides up over the product photo.
 * Touch screens: the panel is moved to <body> and opens as a bottom sheet with a backdrop.
 * Choosing a variant hands it to the theme's own add-to-cart ('theme:cart:add'),
 * so the cart drawer, shipping protection and discounts behave exactly as elsewhere.
 */
(function () {
  if (window.llSliderQuickAdd) return;
  window.llSliderQuickAdd = true;

  var desktopQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var current = null; // { root, panel, opener, sheet }
  var backdrop = null;

  function getBackdrop() {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'll-qa-backdrop';
      backdrop.addEventListener('click', close);
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function open(opener) {
    var root = opener.closest('[data-ll-qa]');
    if (!root) return;
    var panel = root.llPanel || root.querySelector('[data-ll-qa-panel]');
    if (!panel) return;
    root.llPanel = panel;

    if (current && current.panel === panel) return;
    if (current) close(true);

    var sheet = !desktopQuery.matches;
    current = { root: root, panel: panel, opener: opener, sheet: sheet };

    if (sheet) {
      document.body.appendChild(panel);
      panel.classList.add('is-sheet');
      getBackdrop();
      document.documentElement.classList.add('ll-qa-lock');
    } else {
      panel.classList.remove('is-sheet');
    }

    panel.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        if (sheet) backdrop.classList.add('is-open');
        var first = panel.querySelector('[data-ll-qa-variant]:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      });
    });
  }

  function close(instant) {
    if (!current) return;
    var state = current;
    current = null;

    state.panel.classList.remove('is-open');
    state.opener.setAttribute('aria-expanded', 'false');
    state.root.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('ll-qa-lock');

    var finish = function () {
      if (current && current.panel === state.panel) return;
      state.panel.hidden = true;
      if (state.sheet) {
        state.panel.classList.remove('is-sheet');
        state.root.appendChild(state.panel);
      }
    };

    if (instant === true) {
      finish();
    } else {
      setTimeout(finish, 300);
    }

    if (instant !== true && state.root.contains(document.activeElement) === false) {
      state.opener.focus({ preventScroll: true });
    }
  }

  function choose(pill) {
    if (pill.disabled || pill.classList.contains('is-loading')) return;
    var form = pill.closest('form');
    var input = form && form.querySelector('[data-ll-qa-input]');
    if (!input) return;
    input.value = pill.getAttribute('data-ll-qa-variant');

    var error = form.querySelector('[data-ll-qa-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: { button: pill },
      })
    );
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opener = target.closest('[data-ll-qa-open]');
    if (opener) {
      event.preventDefault();
      open(opener);
      return;
    }

    var pill = target.closest('[data-ll-qa-variant]');
    if (pill) {
      event.preventDefault();
      choose(pill);
      return;
    }

    if (target.closest('[data-ll-qa-close]')) {
      event.preventDefault();
      close();
      return;
    }

    // Click anywhere else closes the desktop panel
    if (current && !current.sheet && !current.panel.contains(target)) {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) close();
  });

  // The theme dispatches this on the button once the item is in the cart
  document.addEventListener('theme:product:add', function (event) {
    if (!current) return;
    var button = event.detail && event.detail.button;
    if (button && current.panel.contains(button)) {
      setTimeout(close, 350);
    }
  });

  // Show the cart error (e.g. not enough stock) inside the panel
  document.addEventListener('theme:product:add-error', function (event) {
    if (!current) return;
    var button = event.detail && event.detail.button;
    var data = event.detail && event.detail.response;
    if (!button || !current.panel.contains(button)) return;
    var holder = current.panel.querySelector('[data-ll-qa-error]');
    if (!holder) return;
    holder.textContent = (data && (data.description || data.message)) || '';
    holder.hidden = !holder.textContent;
  });

  // Switching between mouse and touch layouts while open: just close
  var onChange = function () {
    if (current) close(true);
  };
  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', onChange);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(onChange);
  }
})();
